"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialValues = exports.getValidator = void 0;
const lodash_1 = __importDefault(require("lodash"));
const create_validator_1 = __importDefault(require("../create-validator"));
const getValidator = (schema, globalValidator = lodash_1.default.noop) => (values, props) => {
    const schemaValidator = (0, create_validator_1.default)(schema);
    const errors = schemaValidator(values, props);
    if (!lodash_1.default.isEmpty(errors)) {
        return errors;
    }
    const globalError = globalValidator(values, props);
    if (globalError) {
        errors._error = globalError; // eslint-disable-line no-underscore-dangle
    }
    return errors;
};
exports.getValidator = getValidator;
const getInitialValues = (schema) => (0, lodash_1.default)(schema)
    .pickBy((value) => lodash_1.default.has(value, 'initialValue'))
    .mapValues('initialValue')
    .value();
exports.getInitialValues = getInitialValues;
const packageSchemaForReduxForm = (schema, globalValidator) => ({
    initialValues: (0, exports.getInitialValues)(schema),
    validate: (0, exports.getValidator)(schema, globalValidator),
    warn: (0, create_validator_1.default)(schema, 'warning'),
});
exports.default = packageSchemaForReduxForm;
